import { render, staticRenderFns } from "./SendReply.vue?vue&type=template&id=45f961a7&"
import script from "./SendReply.vue?vue&type=script&lang=js&"
export * from "./SendReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports